import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/explore")({
  validateSearch: (search: Record<string, unknown>): {
    scrollTo?: string
  } => ({
    scrollTo: (search.scrollTo as string) || undefined,
  }),
})
